<app-content-filters [userEmail]="userEmail$ | async" (setFiler$)="setFilter($event)"></app-content-filters>
